import React from "react";
import { Check, ChefHat, PackageCheck, X, Clock, Ban } from "lucide-react";
import { useI18n } from "../context/I18nContext";

const LABELS = {
  ORDER_CREATED: "Porudžbina kreirana",
  ORDER_ACCEPTED: "Prihvaćeno",
  ORDER_PREPARING: "Priprema započeta",
  ORDER_READY: "Spremno za preuzimanje",
  ORDER_COMPLETED: "Preuzeto",
  ORDER_REJECTED: "Odbijeno",
  PICKUP_TIME_PROPOSED: "Predloženo novo vreme",
  PICKUP_TIME_ACCEPTED: "Kupac prihvatio novo vreme",
  PICKUP_TIME_DECLINED: "Kupac odbio novo vreme",
  PICKUP_TIME_EXPIRED: "Automatski otkazano — istekao rok (60s)",
  CUSTOMER_CANCELLED: "Kupac otkazao",
  RESTAURANT_CANCELLED: "Restoran otkazao",
  SYSTEM_CANCELLED: "Sistemsko otkazivanje",
};

const ICONS = {
  ORDER_CREATED: Check,
  ORDER_ACCEPTED: Check,
  ORDER_PREPARING: ChefHat,
  ORDER_READY: PackageCheck,
  ORDER_COMPLETED: Check,
  ORDER_REJECTED: X,
  PICKUP_TIME_PROPOSED: Clock,
  PICKUP_TIME_ACCEPTED: Check,
  PICKUP_TIME_DECLINED: X,
  PICKUP_TIME_EXPIRED: Ban,
  CUSTOMER_CANCELLED: X,
  RESTAURANT_CANCELLED: X,
  SYSTEM_CANCELLED: Ban,
};

const NEGATIVE = new Set(["ORDER_REJECTED", "PICKUP_TIME_DECLINED", "PICKUP_TIME_EXPIRED",
  "CUSTOMER_CANCELLED", "RESTAURANT_CANCELLED", "SYSTEM_CANCELLED"]);

function fmtTime(iso) {
  try { return new Date(iso).toLocaleTimeString("sr-RS", { hour: "2-digit", minute: "2-digit" }); }
  catch { return ""; }
}

function detail(e) {
  const m = e.metadata || {};
  if (e.event_type === "PICKUP_TIME_PROPOSED" && m.previous_pickup_time && m.proposed_pickup_time)
    return `${m.previous_pickup_time} → ${m.proposed_pickup_time}`;
  if (e.event_type === "PICKUP_TIME_ACCEPTED" && m.confirmed_pickup_time)
    return `Potvrđeno: ${m.confirmed_pickup_time}`;
  if (e.event_type === "PICKUP_TIME_EXPIRED" && m.proposed_pickup_time)
    return `Predlog: ${m.proposed_pickup_time}`;
  return "";
}

export function OrderTimeline({ events, staff = false }) {
  const { t } = useI18n();
  if (!events || events.length === 0)
    return <p className="text-sm text-slate-400">{t("tl.empty", "Nema zabeleženih događaja.")}</p>;
  return (
    <ol className="relative space-y-4" data-testid="order-timeline">
      {events.map((e, i) => {
        const Icon = ICONS[e.event_type] || Clock;
        const neg = NEGATIVE.has(e.event_type);
        const d = detail(e);
        return (
          <li key={e.id || i} className="flex gap-3" data-testid={`timeline-event-${e.event_type}`}>
            <div className="flex flex-col items-center">
              <span className={`w-7 h-7 rounded-full flex items-center justify-center text-white shrink-0 ${neg ? "bg-brand-red" : "bg-brand-green"}`}>
                <Icon size={14} />
              </span>
              {i < events.length - 1 && <span className="w-px flex-1 bg-slate-200 mt-1" />}
            </div>
            <div className="pb-1 min-w-0">
              <p className="text-sm font-semibold text-slate-800 leading-tight">{t(`tl.${e.event_type}`, LABELS[e.event_type] || e.event_type)}</p>
              {d && <p className="text-xs text-slate-500">{d}</p>}
              <p className="text-[11px] text-slate-400 mt-0.5">
                {fmtTime(e.created_at)}
                {staff && e.actor_name ? ` · ${e.actor_name}` : ""}
                {staff && !e.actor_name && e.actor_type === "SYSTEM" ? " · Sistem" : ""}
              </p>
            </div>
          </li>
        );
      })}
    </ol>
  );
}

export default OrderTimeline;
